module.exports = __webpack_public_path__ + "static/media/background-min.4c121f29.png";